// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn_Submit button {
  /* base button styles can remain in individual form files */
}

.btn_Submit button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* when loading is true the SubmitButton adds this class */
.btn_Submit button.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

/* spinner icon animation used by SubmitButton */
.spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/shared/loader.css"],"names":[],"mappings":"AAAA;EACE,2DAA2D;AAC7D;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,gDAAgD;AAChD;EACE,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC","sourcesContent":[".btn_Submit button {\n  /* base button styles can remain in individual form files */\n}\n\n.btn_Submit button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* when loading is true the SubmitButton adds this class */\n.btn_Submit button.loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n/* spinner icon animation used by SubmitButton */\n.spinner {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
